/* eslint-disable no-irregular-whitespace */
import React from "react";
import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col sm={6}>{new Date().getFullYear()} © {process.env.REACT_APP_TITLE}.</Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Desenvolvido por{" "}
                <a
                  href="https://adasi.com.br/"
                  className="text-sm-end text-primary"
                >
                  Adasi Software
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
